import AssignConfirmationDialog from "./assignConfirmationDialog.container";

export default AssignConfirmationDialog;
